module.exports = __webpack_public_path__ + "static/media/bfile-housemaker.d491650c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-housemaker.svg
// module id = 3103
// module chunks = 0